
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    //import EditFreight from './mainlandfreight-edit.vue'
    import CreateFreight from './userstorageconfig-add.vue'
    import EditModel from './userstorageconfig-edit.vue'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'

    class PageUserStorageConfigRequest extends PageRequest {
        userCode: string;
        isEnable?: boolean;
        constructor() {
           
            super();
            this.isEnable = null;
   
        }
    }

    @Component
        ({
            name: "userstorageconfiglist",
            components: { CreateFreight, EditModel }
        })
    export default class Freogjt extends AbpBase {
        whetherStatus = Enums.getEnum(Enums.IsEffectiveStatus, true);
        editModalShow: boolean = false;
        pagerequest: PageUserStorageConfigRequest = new PageUserStorageConfigRequest();
        creationTime: Date[] = [];
        //editModalShow: boolean = false;
        createModalShow: boolean = false;

        get list() {
            return this.$store.state.backuserstorageconfigSetting.list;
        };
        get loading() {
            return this.$store.state.backuserstorageconfigSetting.loading;
        }
        async allDelete() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            this.$Modal.confirm({
                title: "批量删除", content: "确认批量删除选中数据？", onOk: async () => {
                    var ids = [];
                    for (var i = 0; i < selection.length; i++) {
                        ids.push(selection[i].id);
                    }
                    await this.$store.dispatch({
                        type: 'backuserstorageconfigSetting/delete',
                        data: ids
                    });
                    this.getpage();

                }
            });
        }
        create() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('backuserstorageconfigSetting/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backuserstorageconfigSetting/setPageSize', pagesize);
            this.getpage();
        }

        ShowModel() {
            this.editModalShow = true;
        }

        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters
            //if (this.creationTime.length > 0) {
            //    this.pagerequest.beginTime = this.creationTime[0];
            //}
            //if (this.creationTime.length > 1) {
            //    this.pagerequest.endTime = this.creationTime[1];
            //}

            await this.$store.dispatch({
                type: 'backuserstorageconfigSetting/getAll',
                data: this.pagerequest
            })
        }
        get pageSize() {
            return this.$store.state.backuserstorageconfigSetting.pageSize;
        }
        get totalCount() {
            return this.$store.state.backuserstorageconfigSetting.totalCount;
        }
        get currentPage() {
            return this.$store.state.backuserstorageconfigSetting.currentPage;
        }
        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            }, {
                title: '用户编号',
                key: 'userCode',
                width: 150,
                fixed: 'left',
            },
            {
                title: '类型',
                width: 140,
                key: 'orderType',
                render: (h: any, params: any) => {
                    return h('span', Enums.UserConfigOrderType.filter(function (item) { return item.value == params.row.orderType })[0].name);
                }
            }, {
                title: '仓库名称',
                key: 'warehouseName',
                align: "center",
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.storeName);
                }
            }, {
                title: '打包费用',
                key: 'costPoints',
                width: 120,
            }, {
                title: '是否有效',
                width: 90,
                key: 'isEnable',
                render: (h: any, params: any) => {
                    return h('span', params.row.isEnable ? this.L('是') : this.L('否'))
                }
            }, {
                title: '更新时间',
                key: 'updateTime',
                width: 160,
                render: (h: any, params: any) => {
                    return h('span', DateUtils.formatLongDate(new Date(params.row.updateTime)));
                }
            },
            {
                title: '操作',
                width: 130,
                fixed: 'right',
                key: 'id',
                render: (h: any, params: any) => {
                    var data = params.row;
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small',
                            },
                            style: {
                                marginTop: '5px',
                                width: '90px',
                                height: '30px',
                                display: "inline-block",
                            },
                            on: {
                                click: () => {

                                    _this.$store.state.backuserstorageconfigSetting.updateOrdeData = data;
                                    _this.ShowModel();
                                }
                            }

                        }, "编辑")
                    ]);
                }
            }]
        async created() {
          //  this.getpage();
        }
    }
